<template>
  <div class="container-fluid m-0 p-0">
    <div class="row p-0 m-0">
      <div class="col p-0 m-0">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
          <div class="carousel-inner">

            <!-- Overlay and Writing (Applied to all slides) -->
            <div class="carousel-overlay"></div>
            <div class="carousel-writing  d-flex align-items-center">
              <div class="row col p-0 m-0">
                <h1 class="yellowtail">Paragliding Rome</h1>
              </div>
              <div class="row p-0 m-0 justify-content-center">
                <p class="montserrat">Have you ever dreamt of flying in Rome? You're in the right place!</p>
                <button class="btn btn-primary montserrat" @click="goToBook"
                  style="font-size: medium; width: 350px; background-color: rgb(202, 129, 22); color: white; border: none;">Book
                  Your Experience Now!</button>
              </div>

            </div>


            <!-- Carousel Items -->
            <div class="carousel-item active">
              <img class="d-block w-100" src="/assets/2.jpeg" alt="slide one">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100 img-fluid" src="/assets/4.jpg" alt="slide two">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100 img-fluid" src="/assets/3.jpg" alt="slide three">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100 img-fluid" src="/assets/1.jpg" alt="slide four">
            </div>
          </div>

          <!-- Carousel Controls -->
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade"
            data-bs-slide="prev">

            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade"
            data-bs-slide="next">

            <span class="visually-hidden">Next</span>
          </button>
        </div>

      </div>
    </div>

    <hr>

    <div class="row m-0 p-3">
      <div class="col">
        <div class="container-fluid">
          <div class="row text-center" id="safety">
            <h1 class="pir-color">Safety 🛡️</h1>
          </div>
          <div class="row">
            <div class="col-md-10 offset-md-1 offset-sm-0">
              <p class="lead">
                When you're soaring through the skies, nothing matters more than your safety and that starts with
                choosing the right pilot.
              </p>

              <p>
                At <strong>Paragliding Rome</strong>, safety isn’t just a promise, it’s our core principle.
                Our elite team of certified pilots, recognized by the <em>Italian Aeronautical Club</em>, brings
                decades of experience, competing at national and international levels.
                With every flight, they combine skill, judgment, and passion to ensure your complete security.
              </p>

              <ul class="list-unstyled fs-5">
                <li>✅ Certified Pilots with real competition experience</li>
                <li>✅ State-of-the-art equipment, maintained to perfection</li>
                <li>✅ Advanced safety features including emergency parachutes</li>
                <li>✅ Constant weather monitoring to avoid risky conditions</li>
                <li>✅ No-compromise flight cancellations if safety isn't 100% guaranteed</li>
              </ul>

              <p class="mt-4">
                We don’t just fly, we make sure it’s the <strong>safest flight of your life</strong>.
                So when you take off with us, you can leave your fears on the ground and focus on what really matters:
                the thrill of flying.
              </p>

              <div class="alert alert-info mt-4 text-center fw-semibold" role="alert">
                🧭 Safety isn’t optional - it’s our obsession.<br>
                Trust us to give you the freedom of flight, with the peace of mind you deserve.
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <hr>

    <div class="row m-0 p-3">
      <div class="col" id="places">
        <div class="container-fluid">
          <div class="row text-center">
            <h1 class="pir-color">Places ⛰️</h1>
          </div>
          <div class="row">
            <div class="lead text-center">
               Discover breathtaking paragliding spots across central Italy! 🌄<br>
                Our expert pilots will choose the perfect location for your flight based on the 
                latest weather conditions in order to live the 
                safest and most unforgettable experience possible!
            </div>

          </div>

          
          <div v-for="(place, i) in places" :key="i">
            <div class="row justify-content-center d-flex mb-4 m-0 p-0">
              <div class="col ">
                <PlaceCard :name="place.name" :description="place.description" :index="i" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div class="row m-0 p-3">
      <div class="col">
        <div class="container py-5 text-center">
          <div class="row">
            <div class="col" id="contacts">
              <h1 class="pir-color">Contact Us 📞</h1>
              <p class="lead mt-3">
                Have a question? Need to book last-minute? <br class="d-none d-md-inline" />
                We’re just one tap away and we love to chat! 😄
              </p>
              <p>
                Choose your favorite way to reach us - <strong>calls</strong> are best for fast help!
              </p>
            </div>
          </div>

          <div class="row justify-content-center text-center g-4">
            <div class="col-6 col-md-3">
              <a href="tel:3805991142" class="text-decoration-none" style="color: green;">
                <i class="fa fa-phone fa-2x telephone mb-2"></i>
                <h5 class="mt-2">Phone Call</h5>
              </a>
            </div>
            <div class="col-6 col-md-3">
              <a href="https://wa.me/3805991142" class="text-decoration-none text-success">
                <i class="fa fa-whatsapp fa-2x whatsapp mb-2"></i>
                <h5 class="mt-2">WhatsApp</h5>
              </a>
            </div>
            <div class="col-6 col-md-3">
              <a href="https://telegram.me/flyingmp" class="text-decoration-none text-primary">
                <i class="fa fa-telegram fa-2x telegram mb-2"></i>
                <h5 class="mt-2">Telegram</h5>
              </a>
            </div>
            <div class="col-6 col-md-3">
              <a href="mailto:paraglidingrome@gmail.com?subject=Booking%20for%20YYYY/MM/DD&body=Hello I'm John Doe, my phone is +12 3456789. and I'd like to book..."
                class="text-decoration-none text-danger">
                <i class="fa fa-envelope fa-2x email mb-2"></i>
                <h5 class="mt-2">Email</h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr>
  <div class="row text-center p-0 m-0">
  <div class="col mb-2">
    <a href="/terms" style="color: white;">Terms of Service</a>
  </div>
</div>



</template>

<script>
export default {
  data() {
    return {
      places: [],
    }
  },
  name: "HomePage",
  methods: {
    goToBook() {
      this.$emit("emitPageChange", { page: 'book' });
    },

  },
  async mounted() {
    let resp = await this.$axios.get("/places");
    console.log(resp)
    this.places = resp.data.content
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  .carousel-writing {
    flex-direction: column;
    padding: 10px;
    align-items: center;
  }
}
.btn-primary{
  border : 2px solid !important;
}

.btn-primary:hover{
  border : 2px solid !important;
  background-color: rgba(248, 140, 17, 0.815) !important;
  color: black !important;
}

.yellowtail {
  font-family: "Yellowtail", sans-serif;
  text-shadow: 0px 0px 10px #000000;
  font-weight: 900;
  font-size: 54px;
}

.lora {
  font-family: 'Lora', serif;
  text-shadow: 0px 0px 10px #000000;
  font-size: 21px;
}

.montserrat {
  font-family: 'Montserrat', sans-serif;
  text-shadow: 2px 3px 6px #000000;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 2px;
}

.carousel-inner {
  position: relative;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(172, 94, 5, 0.288);
  /*rgba(190, 107, 13, 0.288);
  190, 108, 13, 0.432*/
  /* Semi-transparent yellow */
  z-index: 2;
  /* Ensure it appears above the images but below the text */
}

@media (max-width: 580px) {
  .carousel-writing {
    margin-top: 65px;
  }
}

.carousel-writing {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 3;
}

/* Ensuring the carousel items are relative to position the overlay */
.carousel-item {
  position: relative;
}

/* Ensuring carousel images fill the container */
.carousel-item img {
  object-fit: cover;
  width: 100%;
  height: 100vh;
  /* Adjust based on your design */
}
</style>